export const selectInitialData = state => state.initialReducer || {};
